<script>
  import _ from 'underscore'
  import ItemBadge from './ItemBadge.vue'

  export default {
    components: { ItemBadge },
    props: {
      date    : { type: String , default: '' },
      items   : { type: Array  , default: () => [] },
      showKira: { type: Boolean, default: false },
      showNico: { type: Boolean, default: false },
      showKR  : { type: Boolean, default: false },
      showHR  : { type: Boolean, default: false },
    },

    data () {
      return {
      }
    },

    computed: {
      /**
       * 自排の所持枚数 (キラチケ, ニコチケ, ノーマル, KR, HR)
       * @return {{ kira:number, nico:number, usual:number, kr:number, hr:number }}
       */
      owned () {
        const items = _.filter(this.items, item => !item.aggregation)
        const nums  = _.pluck(items, 'numOwned')
        const kira  = _.reduce(nums, (sum, numOf) => (!numOf || !numOf.kira ) ? sum : sum + numOf.kira , 0)
        const nico  = _.reduce(nums, (sum, numOf) => (!numOf || !numOf.nico ) ? sum : sum + numOf.nico , 0)
        const usual = _.reduce(nums, (sum, numOf) => (!numOf || !numOf.usual) ? sum : sum + numOf.usual, 0)
        const kr = _.chain(items)
          .where({ rare: 'KR' })
          .pluck('numOwned')
          .reduce((sum, numOf) => !numOf ? sum : sum + (numOf.kira || 0) + (numOf.usual || 0), 0)
          .value()
        const hr = _.chain(items)
          .where({ rare: 'HR' })
          .pluck('numOwned')
          .reduce((sum, numOf) => !numOf ? sum : sum + (numOf.kira || 0) + (numOf.usual || 0), 0)
          .value()
        return { kira, nico, usual, kr, hr }
      },

      /**
       * 自排のち手放した枚数 (キラチケ, ニコチケ, ノーマル, KR, HR)
       * @return {{ kira:number, nico:number, usual:number, kr:number, hr:number }}
       */
      released () {
        const items = _.filter(this.items, item => !item.aggregation)
        const nums  = _.pluck(items, 'numReleased')
        const kira  = _.reduce(nums, (sum, numOf) => (!numOf || !numOf.kira ) ? sum : sum + numOf.kira , 0)
        const nico  = _.reduce(nums, (sum, numOf) => (!numOf || !numOf.nico ) ? sum : sum + numOf.nico , 0)
        const usual = _.reduce(nums, (sum, numOf) => (!numOf || !numOf.usual) ? sum : sum + numOf.usual, 0)
        const kr = _.chain(items)
          .where({ rare: 'KR' })
          .pluck('numReleased')
          .reduce((sum, numOf) => !numOf ? sum : sum + (numOf.kira || 0) + (numOf.usual || 0), 0)
          .value()
        const hr = _.chain(items)
          .where({ rare: 'HR' })
          .pluck('numReleased')
          .reduce((sum, numOf) => !numOf ? sum : sum + (numOf.kira || 0) + (numOf.usual || 0), 0)
          .value()
        return { kira, nico, usual, kr, hr }
      },

      /**
       * 自排枚数 (キラチケ, ニコチケ, ノーマル, kr, hr, 合計枚数, 合計クレジット数)
       * （※なお「合計クレジット数」は、ニコチケ1枚を2クレ、それ以外を1クレで数えた合計）
       * @return {{ kira:number, nico:number, usual:number, kr:number, hr:number, total:number, cost:number }}
       */
      payouts () {
        const { owned, released } = this
        const kira  = owned.kira  + released.kira
        const nico  = owned.nico  + released.nico
        const usual = owned.usual + released.usual
        const kr    = owned.kr    + released.kr
        const hr = owned.hr + released.hr
        const total = kira + usual + nico
        const cost  = kira + usual + nico * 2
        return { kira, nico, usual, kr, hr, total, cost }
      },

      /**
       * キラチケ排出率 (＝キラチケ排出枚数／合計クレジット数) (実数値, 百分率)
       * @return {{ realNumber:number, percentage:number }}
       */
      kiraRatio () {
        const { kira, cost } = this.payouts
        const realNumber = (kira / cost) || 0
        const percentage = Math.round(realNumber * 100 * 1000) / 1000
        return { realNumber, percentage }
      },

      /**
       * KR 排出率 (＝KR排出枚数／合計クレジット数) (実数値, 百分率)
       * @return {{ realNumber:number, percentage:number }}
       */
      krRatio () {
        const { kira, usual, kr } = this.payouts
        const total = kira + usual
        const realNumber = (kr / total) || 0
        const percentage = Math.round(realNumber * 100 * 1000) / 1000
        return { realNumber, percentage }
      },

      /**
       * ハッピーレア排出率 (＝ハッピーレア排出枚数／(キラチケとノーマルチケの排出枚数)) (実数値, 百分率)
       * @return {{ realNumber:number, percentage:number }}
       */
      hrRatio () {
        const { kira, usual, hr } = this.payouts
        const total = kira + usual
        const realNumber = (hr / total) || 0
        const percentage = Math.round(realNumber * 100 * 1000) / 1000
        return { realNumber, percentage }
      },
    },

    watch: {
    },

    created () {
    },

    mounted () {
    },

    beforeDestroy () {
    },

    methods: {
    },

    filters: {
    },
  }
</script>


<template>
  <section class="Status">
    <h2 class="Status__title"><time>{{ date || '(日付なし)' }}</time></h2>
    <table class="Status__body -result">
      <tr><th>プリチケ排出枚数</th><td>…</td><td>{{ payouts.total }} <small>枚</small></td></tr>
      <tr v-if="showNico"><th>・ニコチケ</th><td>…</td><td>{{ payouts.nico }} <small>枚</small></td></tr>
      <tr v-if="showKira"><th>・キラチケ</th><td>…</td><td>{{ payouts.kira }} <small>枚</small></td></tr>
      <tr v-if="showKira"><th>・キラチケ排出率</th><td>…</td><td>{{ kiraRatio.percentage }} <small>％</small></td></tr>
      <tr v-if="showKR"><th>・キラッとレア</th><td>…</td><td>{{ payouts.kr }} <small>枚</small></td></tr>
      <tr v-if="showKR"><th>・キラッとレア排出率</th><td>…</td><td>{{ krRatio.percentage }} <small>％</small></td></tr>
      <tr v-if="showHR"><th>・ハッピーレア</th><td>…</td><td>{{ payouts.hr }} <small>枚</small></td></tr>
      <tr v-if="showHR"><th>・ハッピーレア排出率</th><td>…</td><td>{{ hrRatio.percentage }} <small>％</small></td></tr>
    </table>
    <table class="Status__body -legend">
      <tr v-if="showKira"><th><ItemBadge types="num owned kira" :value="1" /></th><td>…</td><td>自排の所持枚数<small>（キラチケ）</small></td></tr>
      <tr><th><ItemBadge types="num owned usual" :value="1" /></th><td>…</td><td>自排の所持枚数<small v-if="showKira">（<template v-if="showNico">ニコチケ／</template>ノーマル）</small></td></tr>
      <tr v-if="showKira" hidden><th><ItemBadge types="num released kira" :value="1" /></th><td>…</td><td>自排のち手放した枚数<small>（キラチケ）</small></td></tr>
      <tr><th><ItemBadge types="num released usual" :value="1" /></th><td>…</td><td>自排のち手放した枚数<small v-if="showKira" hidden>（<template v-if="showNico">ニコチケ／</template>ノーマル）</small></td></tr>
      <tr><th><ItemBadge types="flag procured" /></th><td>…</td><td>他排を買った・もらった</td></tr>
      <tr><th><ItemBadge types="flag recruiting" /></th><td>…</td><td>お譲りください</td></tr>
    </table>
  </section>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  .Status {
    $text-color: white;
    $text-shadow-color: #ff5555;

    & {
      display: block;
      margin: 0;
      padding: 0;
      font-size: $size-unit * 5;
      font-family: $font-family--fancy;
      font-weight: normal;
      line-height: 1;
      letter-spacing: 1px;
      color: $text-color;
      text-shadow:  0px  3px 1px $text-shadow-color,
                    1px  3px 1px $text-shadow-color,
                    2px  2px 1px $text-shadow-color,
                    3px  1px 1px $text-shadow-color,
                    3px  0px 1px $text-shadow-color,
                    3px -1px 1px $text-shadow-color,
                    2px -2px 1px $text-shadow-color,
                    1px -3px 1px $text-shadow-color,
                    0px -3px 1px $text-shadow-color,
                   -1px -3px 1px $text-shadow-color,
                   -2px -2px 1px $text-shadow-color,
                   -3px -1px 1px $text-shadow-color,
                   -3px  0px 1px $text-shadow-color,
                   -3px  1px 1px $text-shadow-color,
                   -2px  2px 1px $text-shadow-color,
                   -1px  3px 1px $text-shadow-color;
    }

    &__title {
      display: block;
      margin: 0;
      padding: 0;
      font: inherit;
      line-height: 1;
      white-space: nowrap;

      &:not(:last-child) {
        margin-bottom: $size-unit * 4;
      }
    }

    &__body {
      display: table;
      margin: 0;
      padding: 0;
      table-layout: fixed;
      border-collapse: collapse;
      font: inherit;

      &:not(:last-child) {
        margin-bottom: $size-unit * 5;
      }

      th,
      td {
        margin: 0;
        padding: 0;
        text-align: left;
        font: inherit;
        white-space: nowrap;

        &:nth-child(2) {
          padding-left: $size-unit * 2;
          padding-right: $size-unit * 2;
        }

        small {
          font-size: $size-unit * 4;
        }
      }
    }

    &__body.-result {
      th,
      td {
        height: $size-unit * 8;
      }
    }

    &__body.-legend {
      th,
      td {
        height: $size-unit * 9;
      }
    }
  }
</style>
